// Build a WhatsApp click-to-chat link (opens WhatsApp with a pre-filled message).
// No WhatsApp API needed — uses the wa.me deep link.
export function normalizeIndianPhone(phone) {
  const d = String(phone || "").replace(/\D/g, "");
  if (!d) return "";
  if (d.length === 10) return "91" + d;
  if (d.length === 11 && d.startsWith("0")) return "91" + d.slice(1);
  if (d.length === 12 && d.startsWith("91")) return d;
  return d;
}

export function whatsappLink(phone, message) {
  const p = normalizeIndianPhone(phone);
  const base = p ? `https://wa.me/${p}` : "https://wa.me/";
  return `${base}?text=${encodeURIComponent(message)}`;
}
